import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-280834d2")

_pushScopeId("data-v-280834d2")
const _hoisted_1 = { class: "spacName" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h5", {
  id: "detail_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("整体信息")
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "triangles_pie"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "MaxDrawCalls_pie"
}, null, -1)
const _hoisted_5 = { class: "spacName" }
const _hoisted_6 = /*#__PURE__*/_createVNode("h5", {
  id: "detail_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("部件信息")
], -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "triangles"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "MaxDrawCalls"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "triangles_line"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"750px","height":"400px"},
  id: "MaxDrawCalls_line"
}, null, -1)
const _hoisted_11 = { class: "spacName" }
const _hoisted_12 = /*#__PURE__*/_createVNode("h5", {
  id: "detail_scroll",
  class: "TitleStyle"
}, [
  /*#__PURE__*/_createVNode("span"),
  /*#__PURE__*/_createTextVNode("详细信息")
], -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" 动画资源 ")
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 网格资源 ")
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 材质资源 ")
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "subTitle" }, "◆", -1)
const _hoisted_20 = /*#__PURE__*/_createTextVNode(" 纹理资源 ")
const _hoisted_21 = /*#__PURE__*/_createVNode("div", {
  style: {"width":"1600px","height":"400px"},
  id: "triangles_pie_history"
}, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_form = _resolveComponent("el-form")
  const _component_TableView = _resolveComponent("TableView")
  const _component_el_row = _resolveComponent("el-row")
  const _component_h8 = _resolveComponent("h8")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_main = _resolveComponent("el-main")
  const _component_el_container = _resolveComponent("el-container")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock(_component_el_container, null, {
    default: _withId(() => [
      _createVNode(_component_el_container, null, {
        default: _withId(() => [
          _createVNode(_component_el_main, null, {
            default: _withId(() => [
              _createVNode(_component_el_form, {
                inline: true,
                size: "mini"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_form_item, { label: "版本" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.versions,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.versions = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_Versions, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "日期" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.date,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.date = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_ScanTime, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "扫描ID" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.scan_id,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.scan_id = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_RecordID, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "赛车" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.car_name,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.car_name = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_AssetType, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "类型" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.sub_car,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.sub_car = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_AssetSubType, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_form_item, { label: "ID" }, {
                    default: _withId(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.sub_skin,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.sub_skin = $event)),
                        placeholder: "请选择",
                        onChange: _ctx.resouceChange
                      }, {
                        default: _withId(() => [
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.result_AssetID, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: item,
                              label: item,
                              value: item
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "onChange"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_el_card, { class: "tableMinH" }, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_1, [
                    _hoisted_2,
                    _withDirectives(_createVNode(_component_TableView, {
                      columns: _ctx.result_vehicles_columns,
                      tableData: _ctx.resource_vehicle.result_vehicles
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _createVNode(_component_el_row, null, {
                      default: _withId(() => [
                        _hoisted_3,
                        _hoisted_4
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_5, [
                    _hoisted_6,
                    _withDirectives(_createVNode(_component_TableView, {
                      columns: _ctx.result_vehicles_Parts_columns,
                      tableData: _ctx.resource_vehicle.result_vehicles_Parts
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _createVNode(_component_el_row, { style: {"margin":"10px 0px"} }, {
                      default: _withId(() => [
                        _hoisted_7,
                        _hoisted_8
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_row, null, {
                      default: _withId(() => [
                        _hoisted_9,
                        _hoisted_10
                      ]),
                      _: 1
                    })
                  ]),
                  _createVNode("div", _hoisted_11, [
                    _hoisted_12,
                    _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                      default: _withId(() => [
                        _hoisted_13,
                        _hoisted_14
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_TableView, {
                      columns: _ctx.result_animate_list_columns,
                      tableData: _ctx.resource_vehicle.result_animate_list
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                      default: _withId(() => [
                        _hoisted_15,
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_TableView, {
                      class: "spacName",
                      columns: _ctx.result_meshres_list_columns,
                      tableData: _ctx.resource_vehicle.result_meshres_list
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                      default: _withId(() => [
                        _hoisted_17,
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_TableView, {
                      class: "spacName",
                      columns: _ctx.result_materia_list_columns,
                      tableData: _ctx.resource_vehicle.result_materia_list
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _createVNode(_component_h8, { style: {"display":"flex","align-items":"center","margin":"8px 0 8px 0"} }, {
                      default: _withId(() => [
                        _hoisted_19,
                        _hoisted_20
                      ]),
                      _: 1
                    }),
                    _withDirectives(_createVNode(_component_TableView, {
                      class: "spacName",
                      columns: _ctx.result_texture_list_columns,
                      tableData: _ctx.resource_vehicle.result_texture_list
                    }, null, 8, ["columns", "tableData"]), [
                      [_directive_loading, _ctx.resouce_loading]
                    ]),
                    _hoisted_21
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})